import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
	constructor(private router: Router) {}

	canActivate() {
		// Qui il codice per controllare che l' utente sia loggato
		const token = localStorage.getItem('alfresco-ticket');

		if (token) {
			return true;
		}

		this.router.navigate(['/auth']);
		return false;
	}
}
